<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    viewBox="0 0 24 24"
    fill="currentColor">
    <path
      d="M8 10.5378C8 9.43327 8.89543 8.53784 10 8.53784H11.3333C12.4379 8.53784 13.3333 9.43327 13.3333 10.5378V19.8285C13.3333 20.9331 14.2288 21.8285 15.3333 21.8285H16C16 21.8285 12.7624 23.323 10.6667 22.9361C10.1372 22.8384 9.52234 22.5913 9.01654 22.3553C8.37357 22.0553 8 21.3927 8 20.6832V10.5378Z"
      fill="currentColor"></path>
    <rect
      opacity="0.4"
      x="8"
      y="1"
      width="5"
      height="5"
      rx="2.5"
      fill="currentColor"></rect>
  </svg>
</template>
